import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { RIGHT_ALIGNED, RIGHT_ALIGNED_STYLES } from 'common/constants';
import {
  getNumberFromCurrency,
  sortDollarAmounts
} from 'pages/VendorsTablePage/components/VendorsTable/helpers';
import { formatCurrency } from 'utils/formatCurrency';
import { gridHeaders } from './messages';
import { PrintChecksTableData } from './types';

export const usePrintChecksTableColDefs = (
  hideCheckbox?: boolean
): ColDef[] => {
  const intl = useIntl();
  return useMemo(
    () => [
      {
        field: 'vendorNo',
        headerName: intl.formatMessage(gridHeaders.vendorNo),
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: !hideCheckbox,
        suppressColumnsToolPanel: true
      },
      {
        field: 'vendorName',
        headerName: intl.formatMessage(gridHeaders.vendorName),
        minWidth: 250
      },
      {
        field: 'totalNetAmount',
        headerName: intl.formatMessage(gridHeaders.amount),
        type: RIGHT_ALIGNED,
        cellStyle: RIGHT_ALIGNED_STYLES,
        valueGetter: ({ data }: { data: PrintChecksTableData }) =>
          formatCurrency(
            getNumberFromCurrency(data?.totalNetAmount),
            'decimal'
          ),
        comparator: (firstAmount: string, secondAmount: string) =>
          sortDollarAmounts(firstAmount, secondAmount)
      }
    ],
    // REASON FOR DISABLING: We do not want cell renderers to re-render when column defs are updated.
    // To ensure they don't change, we need to wrap them in useMemo() and pass an empty dependency array.
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [hideCheckbox]
  );
};
